import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, computedFrom, Disposable } from 'aurelia-framework';
import { IAccountClassAM, IAccountGroupAM } from '../account-group-api';

@autoinject
export class AccountGroupFilter {
	@bindable accountClasses: IAccountClassAM;
	@bindable onSelect: (params: any) => void;

	selectListOpen = false;
	onBodyClick: (Event) => void;
	dropdownOpenedSubscriber: Disposable;
	selectedAccountGroup: IAccountGroupAM;

	constructor(private eventAggregator: EventAggregator) {
		this.onBodyClick = () => { this.close(); };
	}

	@computedFrom('selectedAccountGroup')
	get selectedAccountGroupId() {
		return this.selectedAccountGroup != null
			? this.selectedAccountGroup.id
			: null;
	}

	attached() {
		document.addEventListener('click', this.onBodyClick);

		this.dropdownOpenedSubscriber =
			this.eventAggregator.subscribe('dropdownOpened', (viewModel: any) => {
				if (viewModel !== this) {
					this.close();
				}
			});
	}

	detached() {
		document.removeEventListener('click', this.onBodyClick);
		this.dropdownOpenedSubscriber.dispose();
	}

	onToggleClick(event: Event) {
		event.stopPropagation();
		this.toggleSelectList();

		if (this.selectListOpen) {
			this.eventAggregator.publish('dropdownOpened', this);
		}
	}

	toggleSelectList() {
		this.selectListOpen = !this.selectListOpen;
	}

	select(accountGroup: IAccountGroupAM) {
		this.selectedAccountGroup = accountGroup;
		this.onSelect({ group: accountGroup });
	}

	close() {
		this.selectListOpen = false;
	}
}
